import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TimeSelect from './TimeSelect';
import Bill from './Bill';
import HowPayDialog from './HowPayDialog';
import { fetchDefault } from '../Utils.js';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import MenuItem from '@material-ui/core/MenuItem';

const monthList = [
    {
        value: 40320,
        label: '4주(28일)',
    },
    {
        value: 80640,
        label: '8주(56일) 3% 추가할인',
    },
    {
        value: 120960,
        label: '12주(84일) 6% 추가할인',
    },
    {
        value: 161280,
        label: '16주(112일) 9% 추가할인',
    },
    {
        value: 201600,
        label: '20주(140일) 12% 추가할인',
    },
    {
        value: 241920,
        label: '24주(168일) 15% 추가할인',
    },
    {
        value: 282240,
        label: '28주(196일) 18% 추가할인',
    },
    {
        value: 322560,
        label: '32주(224일) 21% 추가할인',
    },
    {
        value: 362880,
        label: '36주(252일) 24% 추가할인',
    },
    {
        value: 403200,
        label: '40주(280일) 27% 추가할인',
    },
    {
        value: 443520,
        label: '44주(308일) 30% 추가할인',
    },
    {
        value: 483840,
        label: '48주(336일) 33% 추가할인',
    },
    {
        value: 524160,
        label: '52주(364일) 36% 추가할인',
    }
];

const useStyles = makeStyles(theme => ({
    paper: {
        width: '100%',
        marginTop: 1,
        overflowX: 'auto',
    },
}));

export default function ExtendSeat(props) {
    const classes = useStyles();

    const [startDateTime, setStartDateTime] = React.useState();
    const [time, setTime] = React.useState();
    const [seat, setSeat] = React.useState();
    const [useTimeMin, setUseTimeMin] = React.useState();

    const [originalPrice, setOriginalPricet] = React.useState();
    const [memberDiscount, setMemberDiscount] = React.useState();
    const [usePoint, setUsePoint] = React.useState();
    const [myPoint, setMyPoint] = React.useState();
    const [totalPrice, setTotalPrice] = React.useState();
    

    const onTimeChanged = (t) => {
        setTime(t);

        //계산
        setBill(t, seat);
    };

    const onMonthChanged = (event) => {
        setTime(event.target.value);

        //계산
        setBill(event.target.value, seat);
    };
    
    useEffect(() => {

        //현재 테이블
        fetchDefault('/Payment/GetCurrentSeat?reservationId=' + props.match.params.reservationId,
            (data) => {
                setSeat(data.tableId);
                setStartDateTime(data.endDateTime);
                setUseTimeMin(data.useTimeMin);
                /*
                if (data.useTimeMin < 40320) {
                    setTime(120);
                    setBill(120, data.tableId);
                } else {
                    setTime(40320);
                    setBill(40320, data.tableId);
                }
                */
                
            }
        );

        return () => {
        }
    }, []);

    const setBill = (time, tableId) => {
        fetchDefault('/Payment/GetBill?startDateTime=&time=' + time + '&tableId=' + tableId,
            (data) => {
                setOriginalPricet(data.originalPrice);
                setMemberDiscount(data.memberDiscount);
                setUsePoint(data.usePoint);
                setTotalPrice(data.totalPrice);
                setMyPoint(data.myPoint);
            }
        );
    }

    return (
        <div className={classes.root}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <h2>시간 연장하기</h2>
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="h6">
                        1. 연장하실 시간을 선택해주세요.
                    </Typography>
                </Grid>

                {useTimeMin <= 1440 ? (
                    <Grid item xs={12}>
                        <TimeSelect time={time} onTimeChanged={onTimeChanged} />
                    </Grid>
                ) : (
                    <Grid item xs={12}>
                        <TextField
                            id="outlined-select-currency"
                            select
                            label="기간"
                            className={classes.textField}
                            value={time}
                            onChange={onMonthChanged}
                            SelectProps={{
                                MenuProps: {
                                    className: classes.menu,
                                },
                            }}
                            margin="normal"
                            variant="outlined"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <AccessTimeIcon />
                                    </InputAdornment>
                                ),
                            }}
                        >
                            {monthList.map(option => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid> 
                )}

                <Grid item xs={12}>
                    <Typography variant="h6">
                        2. 결제를 진행해주세요.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Bill originalPrice={originalPrice} memberDiscount={memberDiscount} usePoint={usePoint} myPoint={myPoint}  totalPrice={totalPrice} />
                </Grid>
                <Grid item xs={12}>
                    <HowPayDialog usePoint={usePoint} totalPrice={totalPrice} controllerUrl={'/Payment/UseSeat?startDateTime=' + startDateTime + '&time=' + time + '&seat=' + seat}/>
                </Grid>
            </Grid>
        </div>
    );

}



// WEBPACK FOOTER //
// ./src/components/seat/ExtendSeat.js